import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Button
} from "reactstrap";
import CgnLoader from "../toolbox/CgnLoader";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {
  URL,
  localFilePath,
  fotoStyle2
} from "../../redux/actions/constants";
import pdfIcon from "../../images/pdfIcon.png";
import CgnMessage from "../toolbox/CgnMessage";


class OtherTicketDocumentDetail extends Component {
  state = {
    pageTitle: "Diğer İşlemler Belgeleri Detay (ÜTS Dışı)",
    pageTitleDetail: "Diğer İşlemler Belgeleri Detay (ÜTS Dışı)",
    pageListLink: "diger-islemler-ticket-belgeleri-listele",
    breadcrumb: [{ text: "Diğer İşlemler Belgeleri Detay", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    customerName: "",
    otherTicketImageDto: [],
    customerDocumentOtherGuid: "",
    description: "",
    descriptionError: "",
    descriptionHtml: "",
    otherTicketData: [],
    customerDocumentOtherImageDto: [],
    otherTicket2Dto: [],
    otherTranslationDocumentDto: [],
    status: "",
    customerMail: "",
    customerGuid: "",
    personelName: "",
    guid: "",
    createdAt: "",
    isLoadingModal: false,
    isHiddenSuitable: true,
    isHiddenUnSuitable: true, 
    isOpenModalPayment: false,
    buttons: [
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ]
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
      this.setState({
        isLoading: true,
      });
      this.state.customerGuid = urlSplit[2];
      this.state.customerDocumentOtherGuid = urlSplit[3];
      axios
        .get(URL + "/otherTickets/getlist/" +  this.state.customerGuid + "/" +  this.state.customerDocumentOtherGuid)
        .then((response) => {
          this.setState({
            customerGuid: response.data.customerGuid,
            customerName: response.data.customerName,
            description: this.state.description,
            createdAt: response.data.createdAt,
            customerDocumentOtherImageDto: response.data.customerDocumentOtherImageDto,
            otherTicket2Dto: response.data.otherTicket2Dto,
            customerDocumentOtherGuid: response.data.customerDocumentOtherGuid,
            otherTranslationDocumentDto: response.data.otherTranslationDocumentDto,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
  }

  fileClick = (image) => {
    var myData = image;
    let replaceLink = myData.replace(localFilePath + "/Files/", "");
    if (replaceLink) {
      window.open("/Files/" + myData, "_blank");
      this.setState({
        isLoading: false,
      });
    }
  };

  render() {
    const mainRow = {
      backgroundColor: "#1d4b8c",
      color: "#fff",
    };

    var self1 = this;

    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          listLink={"/" + this.state.pageListLink}
        />
        <Row className="p-3">
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              <div className="row pl-1">
                <p>Müşteri : {this.state.customerName}</p>
              </div>
              {this.state.otherTicket2Dto !== null &&
                this.state.otherTicket2Dto.length > 0 &&
                this.state.otherTicket2Dto.map(function (item) {
                  return (
                    <>
           <Table>
              {item.otherTicketImageDto &&
                 item.otherTicketImageDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2 mb-3">
                    <tr style={mainRow}>
                      <th>Ticket Sisteminden Eklenen Belgeler</th>
                    </tr>
                    <Row>
                      {item.otherTicketImageDto.map(function (item1) {
                        return (
                          <>
                            <div className="pl-4">
                              <Button
                                onClick={() => self1.fileClick(item1.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item1.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "170px" }}>
                                {item1.imageName} - {item1.createdAt}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}
               </Table>
               </>
                 );
              })}

             {this.state.customerDocumentOtherImageDto &&
                this.state.customerDocumentOtherImageDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2 mb-3">
                    <tr style={mainRow}>
                      <th>Müşteri Tarafından Gönderilen ve Sisteme Eklenen Belgeler</th>
                    </tr>
                    <Row>
                      {this.state.customerDocumentOtherImageDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-4">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}

                
             {this.state.otherTranslationDocumentDto &&
                this.state.otherTranslationDocumentDto.length > 0 && (
                  <Table className="table table-responsive table-hover table-product2 mb-3">
                    <tr style={mainRow}>
                      <th>Çeviri Belgeleri</th>
                    </tr>
                    <Row>
                      {this.state.otherTranslationDocumentDto.map(function (item) {
                        return (
                          <>
                            <div className="pl-4">
                              <Button
                                onClick={() => self1.fileClick(item.image)}
                                className="modalButtonDetail"
                              >
                                <img
                                  src={pdfIcon}
                                  style={fotoStyle2}
                                  alt={item.imageName}
                                />
                              </Button>
                              <p style={{ maxWidth: "150px" }}>
                                {item.imageName}
                              </p>
                            </div>
                          </>
                        );
                      })}
                    </Row>
                  </Table>
                )}
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default OtherTicketDocumentDetail;